import seoReducerMap from 'wanderu-ducks-seo';

import CityGuide from '../containers/CityGuide/CityGuide';

function onLoad(module, info, props, context) {
    context.store.inject(seoReducerMap);
}

export { onLoad };
export default CityGuide;
